export default "__VITE_ASSET__Bo4Nd7Hh__"